export const InquiryUrgency = {
  Normal: 508140000,
  Urgent: 508140001,
} as const;
export type InquiryUrgency = (typeof InquiryUrgency)[keyof typeof InquiryUrgency];
